import type { CoverageJobVolumeRow } from "@vellum/vellum-api";

/** Visits and the nurse time that covered them, for a set of facilities. */
export type Workload = {
  visits: number;
  /** Distinct (nurse, week) pairs with at least one visit: weeks actually worked. */
  nurseWeeks: number;
  /** Distinct nurses with at least one visit in the window. */
  nurses: number;
};

export function workloadFor(
  rows: CoverageJobVolumeRow[],
  facilityIds: Set<string>,
): Workload {
  let visits = 0;
  const nurseWeeks = new Set<string>();
  const nurses = new Set<string>();
  for (const row of rows) {
    if (!facilityIds.has(row.facility_id)) continue;
    visits += row.count;
    if (!row.nurse_id) continue;
    nurseWeeks.add(`${row.nurse_id}|${row.week_start}`);
    nurses.add(row.nurse_id);
  }
  return { visits, nurseWeeks: nurseWeeks.size, nurses: nurses.size };
}

/** Visits per nurse per week actually worked; null when nobody worked. */
export function visitsPerNurseWeek(workload: Workload): number | null {
  return workload.nurseWeeks > 0 ? workload.visits / workload.nurseWeeks : null;
}
